
import * as handlebars_family from "../handlebars_family.js";

const TPL = handlebars_family.addTemplate("widget/place-picker",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <flexrow class=\"selectable fw-place-picker-item\" data-fw-metaId=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\" data-fw-formattedaddress=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"address") : depth0)) != null ? lookupProperty(stack1,"formattedAddress") : stack1), depth0))
    + "\"><icon style=\"width:32px;margin:8px\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"icon") : depth0), depth0))
    + "</icon><flexauto> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isTemporary") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":1,"column":211},"end":{"line":1,"column":445}}})) != null ? stack1 : "")
    + " </flexauto></flexrow> ";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <line class=\"sub4\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"address") : depth0)) != null ? lookupProperty(stack1,"formattedAddress") : stack1), depth0))
    + "</line> ";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <line>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"address") : depth0)) != null ? lookupProperty(stack1,"attribute4Line") : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":312},"end":{"line":1,"column":378}}})) != null ? stack1 : "")
    + "</line><line class=\"sub4\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"address") : depth0)) != null ? lookupProperty(stack1,"attribute2Town") : stack1), depth0))
    + "</line> ";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " - "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"address") : depth0)) != null ? lookupProperty(stack1,"attribute4Line") : stack1), depth0));
},"7":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <flexrow class=\"selectable fw-place-picker-item\" data-fw-formattedaddress=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"formattedAddress") : depth0), depth0))
    + "\"><icon style=\"width:32px;margin:8px\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"places.fw_place_mini_unknown",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":626},"end":{"line":1,"column":668}}}))
    + "</icon><flexauto><line>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"formattedAddress") : depth0), depth0))
    + "</line><line class=\"sub4\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"attribute2Town") : depth0), depth0))
    + "</line></flexauto></flexrow> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = "";

  stack1 = ((helper = (helper = lookupProperty(helpers,"places") || (depth0 != null ? lookupProperty(depth0,"places") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"places","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":479}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"places")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  buffer += " ";
  stack1 = ((helper = (helper = lookupProperty(helpers,"items") || (depth0 != null ? lookupProperty(depth0,"items") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"items","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":480},"end":{"line":1,"column":798}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"items")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"useData":true});
export default TPL;